import React from 'react';
import LayoutProvider from '../../../../../../Contexts/LayoutProvider';
import LibModal from '../../../../../../features/LibModal/LibModal';
import { useTemplate } from '../../../../../../features/template/TemplateProvider';
import { handleDeletePackagePriceOpe } from '../../../ProductOperation';
import UpdatePackagePriceModal from '../../Modals/UpdatePackagePriceModal';
import { useProductDt } from '../../ProductDetailsProvider';
import TableMobile from './TableMobile';
import TableWeb from './TableWeb';

function PricingTable({ show }) {
    const {
        openModal,
        closeModal,
        handleReload,
        packageInfo,
        productInfo,
        filteredCurrencies,
        modalType,
        modalData
    } = useProductDt();

    const { setConfirm, setMessage } = useTemplate();

    const data = packageInfo?.prices;

    // package limit my
    const isDuration = packageInfo?.limitBy === 'duration';
    const isLifetime = packageInfo?.limitBy === 'lifetime';

    // check package and product status
    const isPackageOrProductInactive =
        packageInfo?.status === 'inactive' || productInfo?.status === 'inactive';

    // delete pricing
    const handleDelete = (e, priceId) => {
        e.stopPropagation();
        setConfirm({
            text: 'Are you sure you want to delete this pricing?',
            clickAction: () => {
                handleDeletePackagePriceOpe(packageInfo?.applicationId, packageInfo?.id, priceId)
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };

    if (!show) {
        return null;
    }
    return (
        <>
            <LayoutProvider>
                <TableWeb
                    layout="default"
                    data={data}
                    isDuration={isDuration}
                    isLifetime={isLifetime}
                    isPackageOrProductInactive={isPackageOrProductInactive}
                    openModal={openModal}
                    filteredCurrencies={filteredCurrencies}
                    handleDelete={handleDelete}
                />
                <TableMobile
                    layout={['lg', 'md', 'sm', 'xs', 'xxs']}
                    data={data}
                    isDuration={isDuration}
                    isLifetime={isLifetime}
                    isPackageOrProductInactive={isPackageOrProductInactive}
                    openModal={openModal}
                    handleDelete={handleDelete}
                    filteredCurrencies={filteredCurrencies}
                />
            </LayoutProvider>

            {modalType === 'package-pricing' && (
                <LibModal title="Update Package Price" setOpen={closeModal}>
                    <UpdatePackagePriceModal
                        closeModal={closeModal}
                        handleReload={handleReload}
                        data={modalData}
                    />
                </LibModal>
            )}
        </>
    );
}

export default PricingTable;
